  export const TABS_LEARNER = [
    { id: 'development', label: "__CALLS_MY_DEVELOPMENT__", requiresScenario: false },
    { id: 'scorecard',   label: "__CALLS_SCORECARD__",      requiresScenario: true  },
    { id: 'heatmap',     label: "__CALLS_HEATMAP__",        requiresScenario: true  },
    { id: 'mycall',      label: "__CALLS_MY_CALL__",        requiresScenario: true  },
  ];

  export const TABS_NANAGER = [
    { id: 'learners',    label: "__CALLS_LEARNERS__",   },
    { id: 'scorecard',   label: "__CALLS_SCORECARD__",  },
    { id: 'heatmap',     label: "__CALLS_HEATMAP__",    },
  ];
